import map from './map';
import themes from './themes';
import feedbacks from './feedbacks';
import layers from './layers';
import search from './search';
import selections from './selections';
import filters from './filters';
import relations from './relations';
import webtheme from './webtheme';

const actions = {
    ...map.actions,
    ...themes.actions,
    ...feedbacks.actions,
    ...layers.actions,
    ...search.actions,
    ...selections.actions,
    ...filters.actions,
    ...relations.actions,
    ...webtheme.actions,
};
const getters = {
    ...map.getters,
    ...themes.getters,
    ...feedbacks.getters,
    ...layers.getters,
    ...search.getters,
    ...selections.getters,
    ...filters.getters,
    ...relations.getters,
    ...webtheme.getters,
};
const mutations = {
    ...map.mutations,
    ...themes.mutations,
    ...feedbacks.mutations,
    ...layers.mutations,
    ...search.mutations,
    ...selections.mutations,
    ...filters.mutations,
    ...relations.mutations,
    ...webtheme.mutations,
};
const state = {
    ...map.state,
    ...themes.state,
    ...feedbacks.state,
    ...layers.state,
    ...search.state,
    ...selections.state,
    ...filters.state,
    ...relations.state,
    ...webtheme.state,
};

const store = {
    state,

    mutations,

    actions,

    getters
};

export default store;
